import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { endpoints, environment } from '@environment';
import { ApplicationInviteRequest, HouseholdMember } from '@core/models';
import { LanguageService } from '@core/services/language/language.service';
import { Observable } from 'rxjs';
import { suppressGlobalErrorFeedback } from '@core/interceptors';

@Injectable({ providedIn: 'root' })
export class ApplicationInviteService {
  private readonly http = inject(HttpClient);
  private readonly languageService = inject(LanguageService);
  private readonly url = `${environment.authApiUrl}/${endpoints.auth.v1.authSendApplicationInvite}`;

  sendHouseholdMemberInvite(
    member: HouseholdMember,
    contextName?: string,
    inviterName?: string
  ): Observable<void> {
    const email = member.userEmail?.trim().toLowerCase();
    if (!email) {
      throw new Error('Cannot send an invite without a member email.');
    }

    const payload: ApplicationInviteRequest = {
      applicationId: environment.applicationId,
      email,
      recipientName: member.displayName,
      inviterName,
      contextName,
      inviteUrl: this.buildRegisterInviteUrl(email),
      cultureCode: this.languageService.apiCulture(),
    };

    return this.http.post<void>(this.url, payload, { context: suppressGlobalErrorFeedback() });
  }

  private buildRegisterInviteUrl(email: string): string {
    const appUrl = environment.appUrl.replace(/\/+$/, '');
    return `${appUrl}/auth/register?email=${encodeURIComponent(email)}`;
  }
}
